module.exports = require("next/dist/server/capsize-font-metrics.json");